import PropTypes from "prop-types";

import ReportSection from "../../../ui/ReportSection";
import ScenarioTitle from "../../../ui/ScenarioTitle";
import VolumeScenarioReport from "./VolumeScenarioReport";
import PrintableReport from "../../../ui/PrintableReport";
import VcTable from "../../../ui/VcTable";
import {
  STEP_STORAGE_KEYS,
  TRAFFIC_VOLUME_KEYS,
} from "../../../constants/storageConstants";
import {
  CAP_X_STEPPER_STEPS_ORDER,
  STEPS,
} from "../../../constants/stepsConstants";
import ReportSubsection from "../../../ui/ReportSubsection";

function getTitle(stepId) {
  return CAP_X_STEPPER_STEPS_ORDER.find((step) => step.id === stepId).label;
}

export default function CapacityReport({ onClose, projectData, rows }) {
  const trafficVolumes = projectData[STEP_STORAGE_KEYS.TRAFFIC_VOLUMES];
  return (
    <PrintableReport
      onClose={onClose}
      projectData={projectData}
      title="CAP-X Results Report"
    >
      <ReportSection title={getTitle(STEPS.TRAFFIC_VOLUMES)}>
        {Object.entries(trafficVolumes)
          .filter(
            ([scenario]) =>
              scenario === TRAFFIC_VOLUME_KEYS.OPENING_YEAR ||
              scenario === TRAFFIC_VOLUME_KEYS.DESIGN_YEAR
          )
          .map(([scenario, peakPeriods]) => {
            return Object.entries(peakPeriods).map(([periodKey, volumes]) => (
              <ReportSubsection key={periodKey}>
                <ScenarioTitle year={scenario} timePeriod={periodKey} />
                <VolumeScenarioReport volumes={volumes} />
              </ReportSubsection>
            ));
          })}
      </ReportSection>
      <ReportSection title={getTitle(STEPS.CAPACITY_ANALYSIS)}>
        <VcTable rows={rows} />
      </ReportSection>
    </PrintableReport>
  );
}

CapacityReport.propTypes = {
  onClose: PropTypes.func.isRequired,
  projectData: PropTypes.object.isRequired,
  rows: PropTypes.arrayOf(PropTypes.object).isRequired,
};
